import styled from 'styled-components';
import { COLOR_ORANGE } from '../../assets/styles/colors';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  justify-content: space-between;
  .loading-wrap {
    height: 122px;
  }
  .left-wrap {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .back-to-repay {
      font-size: 18px;
      font-weight: bold;
      color: ${COLOR_ORANGE};
      display: flex;
      align-items: center;
      border: none;
      padding: 0px;
      background: none;
      &:hover {
        text-decoration: none;
      }
      svg {
        height: 16px;
        width: 16px;
        margin-right: 8px;
      }
    }
    &--main-headline {
      padding-top: 26px;
      padding-bottom: 0px;
    }
  }

  .right-wrap-card {
    height: auto;
    width: 100%;
    max-width: 405px;
    border-radius: 12px;
    background: linear-gradient(180deg, #434162 0%, #403e5b 32.58%, #38364e 100%);
    box-shadow: 0 8px 15px 0 #2f2e41;
    padding: 16px;

    small {
      padding-bottom: 8px;
    }
    button {
      width: 100%;
    }

    &.sell-transaction {
      &.status {
        width: 405px;
        max-width: 100%;
        min-width: 100%;
        padding: 16px 30px;
        text-align: center;
        small {
          padding-bottom: 2px;
        }
      }
    }

    &.transfer-of-claim {
      margin-top: 15px;
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .left-wrap {
      .back-to-repay {
        justify-content: center;
      }
      &--main-headline {
        padding-top: 15px;
        padding-bottom: 20px;
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    .left-wrap {
      .back-to-repay {
        justify-content: flex-start;
      }
      &--main-headline {
        padding-top: 15px;
        padding-bottom: 20px;
      }
    }
    .right-wrap {
      width: 100%;
      &.sell-transaction {
        max-width: 100%;
        width: 100%;
      }
    }
  }

  .pulsing {
    box-shadow: 0 0 0 0 rgba(247, 147, 30, 0.5);
    animation: pulse 1.5s infinite linear;
    -webkit-animation: pulse 1.5s infinite linear;
  }
  .pulsing:hover {
    animation: none;
    -webkit-animation: none;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.9);
    }
    50% {
      transform: scale(1);

      box-shadow: 0 0 0 25px rgba(247, 147, 30, 0);
    }
    100% {
      transform: scale(0.9);
      box-shadow: 0 0 0 0 rgba(247, 147, 30, 0);
    }
  }
`;
